import styled, { theme, useMediaQuery, mediaQuery, css } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { OZ_DARK, MARIGOLD_DARK } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledSection = styled.section.withConfig({
  displayName: "SplitColorSection__StyledSection",
  componentId: "m9aoxb-0"
})(["color:", ";background:linear-gradient( 90deg,", " 0%,", " 50%,", " 50%,", " 100% );padding-block:120px;", ""], ({
  $colorScheme
}) => $colorScheme === 'light' ? theme.colors.OLAF : 'auto', ({
  $leftColor
}) => $leftColor, ({
  $leftColor
}) => $leftColor, ({
  $rightColor
}) => $rightColor, ({
  $rightColor
}) => $rightColor, mediaQuery('tablet', css(["background:none;padding:0;"])));
const SplitColorSection = ({
  leftContent,
  rightContent,
  leftColor = OZ_DARK,
  rightColor = MARIGOLD_DARK,
  use = 'light'
}) => {
  const {
    isNotTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(StyledSection, {
    $colorScheme: use,
    $leftColor: leftColor,
    $rightColor: rightColor,
    children: isNotTablet ? /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        gap: 60,
        justify: "around",
        children: [/*#__PURE__*/_jsx(UIBox, {
          children: leftContent
        }), /*#__PURE__*/_jsx(UIBox, {
          children: rightContent
        })]
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "p-y-15",
        style: {
          background: leftColor
        },
        children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
          children: /*#__PURE__*/_jsx(UIFlex, {
            justify: "center",
            children: leftContent
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "p-y-15",
        style: {
          background: rightColor
        },
        children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
          children: /*#__PURE__*/_jsx(UIFlex, {
            justify: "center",
            children: rightContent
          })
        })
      })]
    })
  });
};
export default SplitColorSection;